import React from "react";
import PropTypes from "prop-types";
import { Switch, Redirect, Route } from "react-router-dom";

import CtdAnnotateView from "features/ctd/annotate/components/AnnotateView";
import CtdUploadView from "features/ctd/upload/components/UploadView";
import CtdDownloadView from "features/ctd/download/components/DownloadView";
import CtdStatusView from "features/ctd/status/components/StatusView";
import NotFound from "components/404";

const CtdRouter = props => (
  <Switch>
    <Redirect
      exact
      from={`${props.match.url}/`}
      to={`${props.match.url}/upload`}
    />
    <Route path={`${props.match.url}/upload`} component={CtdUploadView} />
    <Route path={`${props.match.url}/annotate`} component={CtdAnnotateView} />
    <Route path={`${props.match.url}/status`} component={CtdStatusView} />
    <Route path={`${props.match.url}/download`} component={CtdDownloadView} />
    <Route component={NotFound} />
  </Switch>
);

CtdRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default CtdRouter;
